import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import { app } from '../firebase';

// Initialize Firestore
const db = getFirestore(app);

// Function to calculate auction statistics
export const getAuctionStats = async (modelId) => {
    try {
        const auctionsQuery = query(
            collection(db, 'auctions'),
            where('modelId', '==', modelId)
        );
        const querySnapshot = await getDocs(auctionsQuery);
        const auctionData = [];
        let totalPrice = 0;
        let highestPrice = 0;
        let lowestPrice = Infinity;
        let soldCount = 0;

        querySnapshot.forEach((doc) => {
            const data = doc.data();
            // Ensure auctionDate and finalBid are properly formatted
            const formattedData = {
                id: doc.id,
                auctionDate: data.auctionDate,  // Should be a date string
                finalBid: parseFloat(data.finalBid),  // Ensure it's a number
                sold: Boolean(data.sold),  // Ensure it's a boolean
                ...data
            };
            console.log('Processing auction data:', formattedData);
            auctionData.push(formattedData);

            const finalBid = parseFloat(data.finalBid);
            if (data.sold) {
                soldCount++;
                totalPrice += finalBid;
                highestPrice = Math.max(highestPrice, finalBid);
                lowestPrice = Math.min(lowestPrice, finalBid);
            }
        });

        console.log('Total auction data:', auctionData);
        const totalListings = querySnapshot.size;
        const stats = {
            sellThroughRate: totalListings > 0 ? Number(((soldCount / totalListings) * 100).toFixed(1)) : 0,
            averagePrice: soldCount > 0 ? totalPrice / soldCount : 0,
            highestPrice: highestPrice,
            lowestPrice: lowestPrice === Infinity ? 0 : lowestPrice
        };

        return { stats, data: auctionData };
    } catch (error) {
        console.error('Error getting auction stats:', error);
        throw error;
    }
};

// Function to calculate auction statistics for filtered data
export const calculateAuctionStats = (auctionData) => {
    let totalPrice = 0;
    let highestPrice = 0;
    let lowestPrice = Infinity;
    let soldCount = 0;
    const totalListings = auctionData.length;

    auctionData.forEach((data) => {
        const finalBid = parseFloat(data.finalBid);
        if (data.sold) {
            soldCount++;
            totalPrice += finalBid;
            highestPrice = Math.max(highestPrice, finalBid);
            lowestPrice = Math.min(lowestPrice, finalBid);
        }
    });

    return {
        sellThroughRate: totalListings > 0 ? Number(((soldCount / totalListings) * 100).toFixed(1)) : 0,
        averagePrice: soldCount > 0 ? Math.round(totalPrice / soldCount) : 0,
        highestPrice: highestPrice,
        lowestPrice: lowestPrice === Infinity ? 0 : lowestPrice
    };
};

// Function to format price as currency
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(price);
};
